// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { ImageFit } from "../components/ImageFit"
import { Layout } from "../components/Layout"
import { tRouteProps, tDefaultTemplate } from "../types"
import { Container } from "../components/StyledComponents"
import { PageMeta } from "../components/PageMeta"
import { css } from "../../node_modules/emotion"
import { mq } from "../styles/variables"
import { setHtml } from "../utils"
import postscribe from "postscribe"

class Podcast extends React.Component {
  componentDidMount() {
    postscribe('#podcasts-embed', "<div id='buzzsprout-small-player-1265879'></div><script type='text/javascript' charset='utf-8' src='https://www.buzzsprout.com/1265879.js?container_id=buzzsprout-small-player-1265879&player=small'></script>");
  }
  render () {
    return (
      <Container
        className={css`
          section {
            padding-top: 60px;
          }

          .title-wrapper {
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;
            flex-wrap: wrap;

            h1 {
              margin-bottom: 10px;
            }

            > * {
              margin: 0;
              line-height: 32px;
            }
          }
        `}
      >
        <PageMeta
          title={this.props.title}
          description={"Regular Podcasts for Spiritual Living"}
          image={{url: "", height: 0, width: 0}}
        />
        <section>
          <div className="title-wrapper">
            <h1 className="h2">{this.props.title}</h1>
          </div>
          <div className="row">
            <div className="content" id="podcasts-embed" />
          </div>
        </section>
      </Container>
    )
  }
}

function RenderPodcast(props) {
  return (
    <Layout>{(routeProps) => <Podcast {...props} {...routeProps} />}</Layout>
  )
}
export default hot(module)(RenderPodcast)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Podcast.js